import React from "react";
import { View, ScrollView, StyleSheet } from "react-native";
import UploadPreview from "../FeedbackScreen/UploadPreview";
import hasVideoExtension from "@microdoing/shared/utils/hasVideoExtension";
import hasAudioExtension from "@microdoing/shared/utils/hasAudioExtension";
import { IFile } from "@microdoing/shared/services/userCampaign/types";
import theme from "app/Theme/Theme";

const styles = StyleSheet.create({
  previews: {
    alignItems: "center",
    justifyContent: "flex-start",
    flexDirection: "row",
    marginTop: theme.spacing.s,
  },
});

interface IProps {
  files: IFile[];
  hasCancelButton?: boolean;
}

const FilesScrollview = ({ files, hasCancelButton = true }: IProps) => {
  return (
    <ScrollView horizontal>
      <View style={styles.previews}>
        {files.map((file, index) => {
          const {
            fileUrl,
            uploadProgress,
            uri,
            filePreview,
            preview,
            fileName,
            duration,
          } = file || {};
          return (
            <UploadPreview
              isVideo={
                hasVideoExtension(uri) ||
                hasVideoExtension(fileName) ||
                !!duration
              }
              hasCancelButton={hasCancelButton}
              isAudio={hasAudioExtension(uri, fileName)}
              fileName={fileName}
              key={index}
              fileUrl={fileUrl || uri}
              uri={preview || filePreview || uri || fileUrl}
              preview={preview || filePreview || fileUrl}
              uploadProgress={uploadProgress}
            />
          );
        })}
      </View>
    </ScrollView>
  );
};

export default FilesScrollview;
